import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-kinderopvang',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-kinderopvang.component.html',
  styleUrl: './tekst-kinderopvang.component.scss',
})
export class TekstKinderopvangComponent {}
